// extracted by mini-css-extract-plugin
module.exports = {"container":"_2nqVSI6rDHF-UVur44HT0z","groupsList":"_12S0CnvD8MOQV6O4KsZWSX"};